import { baseURL } from 'settings';

import { api as apiService, ApiService } from './api';
import { IDriverPeriodParams, IDriverProfile, IDriverPunctuality, IDriverComplaints, IDriverDeliveries, IDriverBoxes } from 'interfaces/IDriverDashboard';

class DriverDashboardService {
  constructor(private readonly api: ApiService, private readonly baseURL: string) { }

  // O backend resolve o motorista pelo token - nenhum desses métodos aceita/envia driverId.
  public getMyDriver = async (): Promise<IDriverProfile> => {
    return await this.api.get(`${this.baseURL}/v1/delivery/me/driver`);
  };

  public getMyPunctuality = async (params: IDriverPeriodParams): Promise<IDriverPunctuality> => {
    return await this.api.get(`${this.baseURL}/v1/delivery/me/punctuality`, { params });
  };

  public getMyComplaints = async (params: IDriverPeriodParams): Promise<IDriverComplaints> => {
    return await this.api.get(`${this.baseURL}/v1/delivery/me/complaints`, { params });
  };

  public getMyDeliveries = async (params: IDriverPeriodParams): Promise<IDriverDeliveries> => {
    return await this.api.get(`${this.baseURL}/v1/delivery/me/deliveries`, { params });
  };

  public getMyBoxes = async (params: IDriverPeriodParams): Promise<IDriverBoxes> => {
    return await this.api.get(`${this.baseURL}/v1/delivery/me/boxes`, { params });
  };
}

export const driverDashboardService = new DriverDashboardService(apiService, baseURL);
